export class ECardResponse {
    id?: number;
    url: string;
    cardName: string;
    success: boolean;
    videoUrl: string;
}